
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Client({client, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={client.logo !== null ? client?.logo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{client?.nom} ({client?.prenom})</div>
                        <div className="widget-subheading">{client?.libtypeclient} ({client?.abrevformejuridique})</div>
                    </div>
                </div>
            </td>
            <td>{client?.email}</td>
            <td>{client?.tel1}</td>
            <td>{client?.tel2 !== null ? client?.tel2 : ""}</td>
            <td><ReactTimeAgo date={Date.parse(client?.datecrea)} timeStyle="facebook" /></td>
            <td className="text-center">
                <Link to={`/client/${client?.code}`} data-toggle="tooltip" title="consulter le client" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}